import type { PropsWithChildren, FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { navBarHeight } from '../navBar.constants'
import { type NavMenuHierarchy } from '../../NavMenuHierarchy'
import { DrawerContentsLeftPane } from './DrawerContentsLeftPane'
import { DrawerContentsRightPane } from './DrawerContentsRightPane'

const DrawerContainer = styled.div<{ verticalOffset?: number }>(({ verticalOffset }) => ({
  display: 'flex',
  marginTop: navBarHeight,
  height: `calc(100vh - ${navBarHeight}px)`,
  paddingTop: `${verticalOffset}px`,
}))

type Props = {
  currentlySelectedItem: number
  setCurrentlySelectedItem: (x: number) => void
  closeDrawer: () => void
  navMenuHierarchy: NavMenuHierarchy
  verticalOffset?: number
}

export const DrawerContents: FunctionComponent<PropsWithChildren<Props>> = ({
  currentlySelectedItem,
  setCurrentlySelectedItem,
  closeDrawer,
  navMenuHierarchy,
  verticalOffset,
}) => (
  <DrawerContainer verticalOffset={verticalOffset || 0}>
    <DrawerContentsLeftPane
      navMenuHierarchy={navMenuHierarchy}
      currentlySelectedItem={currentlySelectedItem}
      setCurrentlySelectedItem={setCurrentlySelectedItem}
    />
    <DrawerContentsRightPane
      navMenuHierarchy={navMenuHierarchy}
      currentlySelectedItem={currentlySelectedItem}
      closeDrawer={closeDrawer}
    />
  </DrawerContainer>
)
